export interface UserEntity {
  binusianId: string;
  name: string;
  email: string;
  businessUnit: string;
  title: string;
  roleId: string;
  status: boolean;
}

export namespace UserEntity {
  export function fromJSON(json: any[]): UserEntity[] {
    return json.map(
      (e): UserEntity => ({
        binusianId: e.binusianID,
        businessUnit: e.businessUnit,
        email: e.email,
        name: e.binusianName,
        roleId: e.roleID,
        status: !e.isDeleted,
        title: e.title,
      })
    );
  }
}
